export enum UserStatus {
  LoggedIn,
  LoggedOut,
}

export interface TrialInfo {
  isTrialNoCard: boolean;
  isTrialNoCardWelcomeScreenShow: boolean;
  isTrialNoCardExpired: boolean;
}

export interface UserInfoState {
  accountCode: string;
  targetAccountCode: string;
  affiliateAccepted: boolean;
  agencyAccount: {
    enabled?: boolean;
    subscriptionId: string;
    remediationAllowedStates?: string[];
  };
  homePage?: string;
  isPartner: boolean;
  open_regulation_tracker: boolean;
  agencyMode: boolean;
  aiPaidUser: boolean;
  created_at?: string;
  discount: string;
  discount_expires_at: string;
  email?: string;
  everflowClickId?: string;
  firstName: string;
  isMasterAccount?: boolean;
  isTrialApplicable?: boolean;
  is_blocked?: boolean;
  is_feedback_g2_submitted: boolean;
  is_feedback_submitted: boolean;
  is_feedback_trustpilot_submitted: boolean;
  lastName: string;
  parent_id?: string;
  phone?: string;
  releasesSubscriber?: boolean;
  removedSitesCount: string;
  role?: string;
  siteCreateOnTunings: {enabled: boolean};
  siteCreateOnTuningsEnabled: boolean;
  siteCreateReviewList: boolean;
  sitesCount: number;
  totalSitesLoads: number;
  id: string;
  userStatus: UserStatus;
  username: string;
  ssoUserId?: string;
  targetSsoUserId?: string;
  status?: string;
  walkthroughStatus: {[key: string]: boolean};
  code: string;
  regulation_tracker_mode_only?: boolean;
  regulationTrackerMode?: boolean;
  isFixMyCodeEnabled: boolean;
  trialInfo?: TrialInfo;
}
